// src/axiosInstance.js
import axios from 'axios';
import strings from './String';

const axiosInstance = axios.create({
  baseURL: strings.apiBaseUrl,
  withCredentials:true
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // You can modify the request config before the request is sent
    const token = localStorage.getItem('authToken');  // Example of getting a token from localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;  // Add the token to the request header
    }
    const convId = localStorage.getItem("conversationId");
    if (convId) {
      config.headers['convId'] = convId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // You can modify the response before it's returned to the calling code
    return response;
  },
  (error) => {
    // Handle errors globally, like unauthorized access or timeouts
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // Unauthorized, redirect to login page or show an error
          break;
        case 500:
          // Server error, show an appropriate message
          break;
        default:
          break;
      }
    } else if (error.request) {
      // Request was made, but no response was received
      console.error('No response received');
    } else {
      // Something else happened while setting up the request
      console.error('Request error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
